<footer
  id="kapcsolat"
  class="border-t border-white/10 bg-black text-white"
>
  <div class="mx-auto max-w-7xl px-6 py-12">

    <div class="grid gap-10 text-center md:grid-cols-3 md:text-left">

      <div class="flex flex-col items-center md:items-start">
        <div class="bulls-barber-seal-container">
          <a routerLink="/" (click)="onLogoClick($event)">
            <img
              src="/images/bonefade-source/bulls-white-logo-seal.png"
              alt="Bonefade Barbers"
            />
          </a>
        </div>
      </div>

      <div>
        <h3 class="font-bold uppercase tracking-wider">
          Navigáció
        </h3>

        <div class="mt-4 flex flex-col items-center gap-2 text-sm text-white/60 md:items-start">
          <a
            href="/"
            appScrollToSection="bf-summary"
            class="hover:text-white"
          >
            Rólunk
          </a>

          <a
            href="/arak"
            appScrollToSection="price-list"
            [scrollBelowBreakpoint]="1024"
            routeTarget="/arak"
            class="hover:text-white"
          >
            Árak
          </a>

          <a
            href="/galeria"
            appScrollToSection="gallery-grid"
            [scrollBelowBreakpoint]="1024"
            routeTarget="/galeria"
            class="hover:text-white"
          >
            Galéria
          </a>

          <a
            href="/#kapcsolat"
            appScrollToSection="kapcsolat"
            [global]="true"
            class="hover:text-white"
          >
            Kapcsolat
          </a>
        </div>
      </div>

      <div>
        <h3 class="font-bold uppercase tracking-wider">
          Kapcsolat
        </h3>

        <div class="mt-4 flex flex-col items-center gap-2 text-sm text-white/60 md:items-start">
          <p>Budapest</p>
          <p>
            <a href="tel:+36304918297" class="hover:text-white">
              +36 30 491 8297
            </a>
          </p>
          <p>
            <a href="mailto:hello@bullsbarber.hu" class="hover:text-white">
              hello@bullsbarber.hu
            </a>
          </p>

          <app-social-links marginTop="2px"></app-social-links>
        </div>
      </div>

    </div>

    <p class="mt-4 text-center text-sm leading-6 text-white/50 md:text-left">
      Modern barber shop azoknak, akiknek számít a stílus,
      a részletek és a minőség.
    </p>

    <div class="text-center text-sm text-white/30 md:text-right">
      © {{ currentYear }} Bulls Barber. Minden jog fenntartva.
    </div>

  </div>
</footer>
